import type { AppSettings } from '../core/types';

export const DEFAULT_SETTINGS: Readonly<AppSettings> = Object.freeze({
  profileName: 'PLAYER 01',
  age: 34,
  position: 'field',
  onboardingComplete: false,
  preferredKeys: Object.freeze({
    choice1: '1',
    choice2: '2',
    choice3: '3',
    choice4: '4',
    pause: 'Escape',
  }),
});

export function mergeSettings(
  current: Readonly<AppSettings>,
  update: Partial<AppSettings>,
): AppSettings {
  const age = update.age ?? current.age;
  if (!Number.isInteger(age) || age < 18 || age > 120) {
    throw new RangeError('age must be an integer between 18 and 120');
  }
  return {
    ...current,
    ...update,
    age,
    position: 'field',
    preferredKeys: {
      ...current.preferredKeys,
      ...update.preferredKeys,
    },
  };
}

export function createDefaultSettings(): AppSettings {
  return mergeSettings(DEFAULT_SETTINGS, {});
}
